import React, { useState, Fragment } from "react";
import { FieldArray, Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHomeContext } from "../../../context/HomeContext";
import { useThemeContext } from "../../../context/ThemeContext";
import { ThreeDots } from "react-loader-spinner";
import { useMutation, useQuery } from "react-query";
import { useAuth } from "../../../context/auth";
import { AiFillPlusCircle } from "react-icons/ai";
import { MdOutlineRemoveCircle } from "react-icons/md";
import axios from "axios";

import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../../../Utils/firebase";
const AddRealEstateForm = ({ setIsModalOpen, editId, setEditId }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [file, setFile] = useState(null);
  const { currentMode } = useThemeContext();
  const { token, user } = useAuth();
  const agentSchema = Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    address: Yup.string().required("address is Required"),
    phone: Yup.string().required("phone is Required"),
  });
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  const onSubmit = async (
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) => {
    try {
      if (editId) {
        if (file) {
          uploadImage(values);
        } else {
          editOwnerHandler(values);
        }
        resetForm({});
        setStatus({ success: true });
      } else {
        if (file) {
          uploadImage(values);
        } else {
          createOwnerHandler(values);
        }
        resetForm({});
        setStatus({ success: true });
      }
    } catch (error) {
      setStatus({ success: false });
      setSubmitting(false);
      setErrors({ submit: error.message });
    }
  };

  const uploadImage = (values) => {
    setIsUploading(true);
    const fileName = new Date().getTime() + file.name;
    const storage = getStorage(app);
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setIsUploading(false);
          if (editId) {
            editOwnerHandlerWithProfile({
              image: downloadURL,
              values: values,
            });
          } else {
            createOwnerHandlerWithProfile({
              image: downloadURL,
              values: values,
            });
          }
        });
      }
    );
  };
  const ownerData = useQuery(
    ["ownerDataApi", editId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}owner/find/${editId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!editId,
      onSuccess: (res) => {},
    }
  );

  const ownerMutation = useMutation(
    async (newData) =>
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}owner/create`,
        newData,
        {
          headers,
        }
      ),
    {
      retry: false,
    }
  );

  //cxreate agent with profile
  const createOwnerHandlerWithProfile = async (data) => {
    try {
      ownerMutation.mutate(
        {
          name: data.values.name,
          address: data.values.address,
          logo: data.image,
          phone: data.values.phone,
        },
        {
          onSuccess: (responseData) => {
            setIsModalOpen(false);
            setFile(null);
            toast.info(
              "Real Estate created Successfully",
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
          onError: (err) => {
            toast.error(
              err?.response?.data?.message,
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };
  const createOwnerHandler = async (values) => {
    try {
      ownerMutation.mutate(
        {
          name: values.name,
          address: values.address,
          phone: values.phone,
        },
        {
          onSuccess: (responseData) => {
            setIsModalOpen(false);
            toast.info(
              "Real Estate created Successfully",
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
          onError: (err) => {
            toast.error(
              err?.response?.data?.message,
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const editOwnerMutation = useMutation(
    async (newData) =>
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}owner/find/${editId}`,
        newData,
        {
          headers,
        }
      ),
    {
      retry: false,
    }
  );

  //edit with profile
  const editOwnerHandlerWithProfile = async (data) => {
    try {
      editOwnerMutation.mutate(
        {
          name: data.values.name,
          address: data.values.address,
          logo: data.image,
          phone: data.values.phone,
        },
        {
          onSuccess: (responseData) => {
            setFile(null);
            setEditId(null);
            setIsModalOpen(false);
            toast.info(
              "Real Estate edited Successfully",
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
          onError: (err) => {
            toast.error(
              err?.response?.data?.message,
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };
  const editOwnerHandler = async (values) => {
    try {
      editOwnerMutation.mutate(
        {
          name: values.name,
          address: values.address,
          phone: values.phone,
        },
        {
          onSuccess: (responseData) => {
            setEditId(null);
            setIsModalOpen(false);
            toast.info(
              "agent edited Successfully",
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
          onError: (err) => {
            toast.error(
              err?.response?.data?.message,
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <h1
        className={` ${
          currentMode === "Dark" ? " text-gray-300 " : "text-dark-gray"
        } 
        text-xl font-semibold w-full text-center pb-3`}
      >
        {editId
          ? ownerData.isFetched
            ? `Edit ${ownerData?.data?.data?.data?.name}`
            : null
          : "Add New Real Estate"}
      </h1>
      {editId ? (
        ownerData.isFetched ? (
          isUploading ? (
            <div className="flex items-center justify-center p-3 py-14">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          ) : (
            <Formik
              initialValues={
                editId
                  ? ownerData.isFetched && ownerData?.data?.data?.data
                  : {
                      name: "",
                      address: "",
                      phone: "",
                    }
              }
              validationSchema={agentSchema}
              onSubmit={onSubmit}
            >
              {({ errors, touched, values }) => (
                <Form className="flex flex-col items-start space-y-2">
                  <div className="w-full flex flex-col items-start space-y-1">
                    <span
                      className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                    >
                      Real Estate Name
                    </span>
                    <Field
                      as="input"
                      name="name"
                      placeholder="name"
                      className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                        currentMode !== "Dark"
                          ? "border "
                          : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                      }  ${
                        errors.name && touched.name
                          ? "border border-red-600"
                          : "border border-slate-400  "
                      }`}
                    />
                    {errors.name && touched.name ? (
                      <p className="text-[13px] text-red-500">{errors.name}</p>
                    ) : null}
                  </div>
                  <div className="w-full flex flex-col items-start space-y-1">
                    <span
                      className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                    >
                      Address
                    </span>
                    <Field
                      as="input"
                      name="address"
                      placeholder="address"
                      className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                        currentMode !== "Dark"
                          ? "border "
                          : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                      }  ${
                        errors.address && touched.address
                          ? "border border-red-600"
                          : "border border-slate-400  "
                      }`}
                    />
                    {errors.address && touched.address ? (
                      <p className="text-[13px] text-red-500">
                        {errors.address}
                      </p>
                    ) : null}
                  </div>

                  {/* phone */}
                  <div className="w-full flex flex-col items-start space-y-1">
                    <span
                      className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                    >
                      Phone
                    </span>
                    <Field
                      as="input"
                      name="phone"
                      placeholder="phone"
                      className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                        currentMode !== "Dark"
                          ? "border "
                          : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                      }  ${
                        errors.phone && touched.phone
                          ? "border border-red-600"
                          : "border border-slate-400  "
                      }`}
                    />
                    {errors.phone && touched.phone ? (
                      <p className="text-[13px] text-red-500">{errors.phone}</p>
                    ) : null}
                  </div>
                  {/* profile */}
                  <div className="w-full flex flex-col">
                    <span
                      className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                    >
                      Logo
                    </span>
                    <input
                      type="file"
                      onChange={(e) => setFile(e.target.files[0])}
                      className={`${
                        currentMode === "Dark"
                          ? "bg-[#2C3345] border border-slate-400 text-slate-200"
                          : ""
                      } rounded-sm focus:outline-none focus:ring-0 border border-[#96a0af]`}
                    />
                  </div>

                  <button
                    disabled={editOwnerMutation.isLoading}
                    type="submit"
                    className="p-2 w-full flex items-center justify-center bg-[#216fed] font-medium text-white 
          rounded-md"
                  >
                    {editOwnerMutation.isLoading ? (
                      <ThreeDots
                        height="25"
                        width="50"
                        radius="9"
                        color="#fff"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    ) : (
                      "Edit Real Estate"
                    )}
                  </button>
                </Form>
              )}
            </Formik>
          )
        ) : (
          // end
          <div className="flex items-center justify-center p-5">
            <ThreeDots
              height="25"
              width="50"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )
      ) : isUploading ? (
        <div className="flex items-center justify-center p-3 py-14">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#216fed"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      ) : (
        <Formik
          initialValues={
            editId
              ? ownerData.isFetched && ownerData?.data?.data?.data
              : {
                  name: "",
                  address: "",
                  phone: "",
                }
          }
          validationSchema={agentSchema}
          onSubmit={onSubmit}
        >
          {({ errors, touched, values }) => (
            <Form className="flex flex-col items-start space-y-2">
              <div className="w-full flex flex-col items-start space-y-1">
                <span
                  className={`font-medium text-sm 
                 ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                >
                  Real Estate Name
                </span>
                <Field
                  as="input"
                  name="name"
                  placeholder="name"
                  className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                    currentMode !== "Dark"
                      ? "border "
                      : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                  }  ${
                    errors.name && touched.name
                      ? "border border-red-600"
                      : "border border-slate-400  "
                  }`}
                />
                {errors.name && touched.name ? (
                  <p className="text-[13px] text-red-500">{errors.name}</p>
                ) : null}
              </div>
              <div className="w-full flex flex-col items-start space-y-1">
                <span
                  className={`font-medium text-sm 
                 ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                >
                  Address
                </span>
                <Field
                  as="input"
                  name="address"
                  placeholder="address"
                  className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                    currentMode !== "Dark"
                      ? "border "
                      : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                  }  ${
                    errors.address && touched.address
                      ? "border border-red-600"
                      : "border border-slate-400  "
                  }`}
                />
                {errors.address && touched.address ? (
                  <p className="text-[13px] text-red-500">{errors.address}</p>
                ) : null}
              </div>

              {/* Phone */}
              <div className="w-full flex flex-col items-start space-y-1">
                <span
                  className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                >
                  Phone
                </span>
                <Field
                  as="input"
                  name="phone"
                  placeholder="phone"
                  className={`rounded-sm w-full h-[42px] focus:outline-none  border text-dark-gray  ${
                    currentMode !== "Dark"
                      ? "border "
                      : "border border-slate-400 text-gray-200 bg-[#2C3345]"
                  }  ${
                    errors.phone && touched.phone
                      ? "border border-red-600"
                      : "border border-slate-400  "
                  }`}
                />
                {errors.phone && touched.phone ? (
                  <p className="text-[13px] text-red-500">{errors.phone}</p>
                ) : null}
              </div>
              {/* Logo */}
              <div className="w-full flex flex-col">
                <span
                  className={`font-medium text-sm 
                  ${currentMode === "Dark" ? "text-dark-gray" : ""}`}
                >
                  Logo
                </span>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  className={`${
                    currentMode === "Dark"
                      ? "bg-[#2C3345] border border-slate-400 text-slate-200"
                      : ""
                  } rounded-sm focus:outline-none focus:ring-0 border border-[#96a0af]`}
                />
              </div>

              {editId ? (
                <button
                  disabled={editOwnerMutation.isLoading}
                  type="submit"
                  className="p-2 w-full flex items-center justify-center bg-[#216fed] font-medium text-white 
         rounded-md"
                >
                  {editOwnerMutation.isLoading ? (
                    <ThreeDots
                      height="25"
                      width="50"
                      radius="9"
                      color="#fff"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    "Edit Edit Real Estate"
                  )}
                </button>
              ) : (
                <button
                  disabled={ownerMutation.isLoading}
                  type="submit"
                  className="p-2 w-full flex items-center justify-center bg-[#216fed] font-medium text-white 
            rounded-md"
                >
                  {ownerMutation.isLoading ? (
                    <ThreeDots
                      height="25"
                      width="50"
                      radius="9"
                      color="#fff"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    "Create Real Estate"
                  )}
                </button>
              )}
            </Form>
          )}
        </Formik>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
        limit={1}
      />
    </div>
  );
};

export default AddRealEstateForm;
